import ConstructorPage from 'units/constructor-local/containers/Page/Page';
import connectWithApp from 'hoc/connectWithApp';

export default connectWithApp(ConstructorPage);
